import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, formatDate, SubmitBtn, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select'
import { currentDateAndTime, decodeData } from '../../Constants/constants';

class OTLogs extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_overtime_id: 0,
            employee_id: 0,
            company_overtime_id: 0,
            employee_overtime_hours: '',
            employee_overtime_date: '',
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            employee_verified_row: [],
            over_time_row: [],
            errors: {},
            loadingList: false,
            postLoading: false,
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetEmployeesVerifiedList();
            this.GetOverTimeList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetOverTimeLogInfo?employee_overtime_id=${this.state.employee_overtime_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        company_overtime_id: data[0].company_overtime_id,
                        employee_id: data[0].employee_id,
                        employee_overtime_hours: data[0].employee_overtime_hours,
                        employee_overtime_date: data[0].employee_overtime_date,
                        errors: {},
                        

                    }
                )
            }
        });
    }
    GetEmployeesVerifiedList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        employee_verified_row: data.data.map((row) => ({
                            value: row.employee_id,
                            label: row.employee_name
                        }))
                    }));
                }
            });
    }

    GetOverTimeList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetOverTimeList`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        over_time_row: data.data.map((row) => ({
                            value: row.company_overtime_id,
                            label: row.overtime_type_name
                        }))
                    }));
                }
            });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetOverTimeLogs`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }


    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            company_overtime_id: this.state.company_overtime_id,
            employee_id: this.state.employee_id,
            employee_overtime_hours: this.state.employee_overtime_hours,
            employee_overtime_date: this.state.employee_overtime_date,
            date: currentDateAndTime()
        }
        if (this.state.employee_overtime_id !== 0) {
            formData.employee_overtime_id = this.state.employee_overtime_id;
        }
        axios
            .post(`${apiURL}Masters/CreateOverTimeLog`, formData, { headers })
            .then((response) => {

                const { success } = response.data;

                if (success === true) {
                    this.resetForm();

                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                }

            })
    };

    resetForm = () => {
        this.setState({
            employee_overtime_id: 0,
            company_overtime_id: 0,
            employee_id: 0,
            employee_overtime_hours: '',
            employee_overtime_date: '',
        })

    }
    validateForm = () => {
        const errors = {};

        if (this.state.company_overtime_id === 0) {
            errors.company_overtime_id = 'Select over is required';
        }
        if (this.state.employee_id === 0) {
            errors.employee_id = 'Select employee is required';
        }
        if (!this.state.employee_overtime_hours) {
            errors.employee_overtime_hours = 'Over time hours is required';
        }
        if (!this.state.employee_overtime_date) {
            errors.employee_overtime_date = 'Over time date is required';
        }

        return errors;
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    employee_overtime_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteOverTimeLog`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Over Time Log's Master`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Over Time Log's</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-6 mt-3">
                                                        <label>Select Over Time</label>
                                                        <Select onChange={(selectedOption) => this.handleSelectChange('company_overtime_id', selectedOption)}
                                                        isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                         placeholder={`Select Over Time`} options={this.state.over_time_row} value={this.state.company_overtime_id ? this.state.over_time_row.find(option => option.value === this.state.company_overtime_id) : null} />
                                                        {errors.company_overtime_id && <div className="text-danger">{errors.company_overtime_id}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label>Select Employee</label>
                                                        <Select onChange={(selectedOption) => this.handleSelectChange('employee_id', selectedOption)}
                                                        isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                         placeholder={`Select Employee`} options={this.state.employee_verified_row} value={this.state.employee_id ? this.state.employee_verified_row.find(option => option.value === this.state.employee_id) : null} />
                                                        {errors.employee_id && <div className="text-danger">{errors.employee_id}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_overtime_hours" className="form-label">Over Time Hours</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.employee_overtime_hours ? 'is-invalid' : ''}`}
                                                            id="employee_overtime_hours"
                                                            name="employee_overtime_hours"
                                                            value={this.state.employee_overtime_hours}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Over Time Hours"
                                                        />
                                                        {errors.employee_overtime_hours && <div className="text-danger">{errors.employee_overtime_hours}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_overtime_date" className="form-label">Over TIme Date</label>
                                                        <input
                                                            type="date"
                                                            className={`form-control ${errors.employee_overtime_date ? 'is-invalid' : ''}`}
                                                            id="employee_overtime_date"
                                                            name="employee_overtime_date"
                                                            value={this.state.employee_overtime_date}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Effective Date"
                                                        />
                                                        {errors.employee_overtime_date && <div className="text-danger">{errors.employee_overtime_date}</div>}
                                                    </div>

                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.employee_overtime_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.employee_overtime_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.employee_overtime_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)
                                                        }

                                                        {
                                                            this.state.employee_overtime_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Selected Employee's</th>
                                                    <th>Over Time Hours</th>
                                                    <th>Over Time Date</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th className='text-center' width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.employee_overtime_id}>
                                                            <td>{row.employee_label[0].ot_employee_name}</td>
                                                            <td>{row.employee_overtime_hours}</td>
                                                            <td>{formatDate(row.employee_overtime_date)}</td>

                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => this.setState({ employee_overtime_id: row.employee_overtime_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                    <button onClick={() => this.handleDelete(row.employee_overtime_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }

                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>

                                            </tfoot>

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(OTLogs);



